import React from "react";

const convertUtcToLocal = (
  utcDate: string,
  timeZone: string,
  formatPattern?: any
) => {
  const date = new Date(utcDate);

  if (timeZone === "Asia/Calcutta") {
    timeZone = "Asia/Kolkata"; // 🔥 fix old timezone
  }

  return date.toLocaleString(
    timeZone || "en-US",
    formatPattern || {
      timeZone,
      dateStyle: "medium",
      timeStyle: "short",
      hour12: true,
    }
  );
};

const formatDateIfValid = (value: any) => {
  if (!value) return value;

  let date = new Date(value);
  if (String(value).includes("T") && !isNaN(date.getTime())) {
    const d = date
      .toLocaleString("en-US", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      })
      .replace(",", "");
    return d;
  }

  // Date without time
  if (!isNaN(date.getTime())) {
    return date.toLocaleDateString("en-US");
  }

  return value;
};

const stripHtml = (html: string = ""): string => {
  return html.replace(/<[^>]+>/g, "").trim();
};

const withSearchIcon = (
  label: string,
  options?: { clickable?: boolean; onClick?: () => void }
) => {

  return `${label} 🔍`;
};

export { convertUtcToLocal, formatDateIfValid, stripHtml ,withSearchIcon};
